import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12.87 3l9.52 16.5a1 1 0 01-.86 1.5H2.47a1 1 0 01-.86-1.5L11.13 3a1 1 0 011.74 0zM11 16v2h2v-2h-2zm0-7v5h2V9h-2z"/>
  </SvgIcon>
);